import { Injectable, inject } from '@angular/core';
import { formatDate } from '@angular/common';
import { SupportInformation } from '../models/support.model';
import { ActivatedRoute } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class SupportService {
    readonly #route = inject(ActivatedRoute);

    generateSupportInfo(outputType: string, data: SupportInformation): string {
        const queryParams = this.#route.snapshot.queryParams;

        const lastUpdatedAt = data.lastUpdatedAt ? this.formatDate(data.lastUpdatedAt) : '';
        const eloquaInstanceId = data.eloquaInstanceId ? data.eloquaInstanceId : queryParams['instanceid'];
        const installId = data.installId ? data.installId : queryParams['installid'];
        const assetId = queryParams['assetid'];
        const assettype = queryParams['assettype'];
        const eloquaUsername = data.eloquaUsername ? data.eloquaUsername : queryParams['username'];
        const eloquaSitename = data.eloquaSitename ? data.eloquaSitename : queryParams['sitename'];
        const url = window.location.href;

        let supportInfo = '';

        if (outputType === 'html') {
            supportInfo = `<b>App Instance ID</b>: ${data.appInstanceId}<br>
<b>App Name</b>: ${data.appName}<br>
<b>Global App ID</b>: ${data.globalAppId}<br>
<b>Account Name</b>: ${data.accountName}<br>
<b>Account ID</b>: ${data.accountId}<br>
<b>Username</b>: ${data.appcloudUsername}<br>
<b>Last Updated At</b>: ${lastUpdatedAt}<br>
<b>Eloqua Instance ID</b>: ${eloquaInstanceId}<br>
<b>Eloqua Install ID</b>: ${installId}<br>
<b>Eloqua Asset ID</b>: ${assetId}<br>
<b>Eloqua Asset Type</b>: ${assettype}<br>
<b>Eloqua User</b>: ${eloquaUsername}<br>
<b>Eloqua Site Name</b>: ${eloquaSitename}<br>
<b>URL</b>: ${url}<br>
<b>App License Id</b>: ${data.licenseId} <br>
<b>App License Expires</b>: ${data.licenseEndDate} <br>
<b>Browser</b>: ${navigator.userAgent} <br>`;
        } else {
            supportInfo = `App Instance ID: ${data.appInstanceId}
App Name: ${data.appName}
Global App ID: ${data.globalAppId}
Account Name: ${data.accountName}
Account ID: ${data.accountId}
Username: ${data.appcloudUsername}
Last Updated At: ${lastUpdatedAt}
Eloqua Instance ID: ${eloquaInstanceId}
Eloqua Install ID: ${installId}
Eloqua Asset ID: ${assetId}
Eloqua Asset Type: ${assettype}
Eloqua User: ${eloquaUsername}
Eloqua Site Name: ${eloquaSitename}
URL: ${url}
App License Id: ${data.licenseId}
App License Expires: ${data.licenseEndDate}
Browser: ${navigator.userAgent}`;
        }

        return supportInfo.replace(/: undefined/g, ': ');
    }

    private formatDate(date: Date) {
        return formatDate(date, 'yyyy-MM-dd HH:mm:ss', 'en-US', '+0000') + '+0000';
    }
}
